import { App, routes as allRoutes } from "@songtradr-sso/shared/common";
import { redirect } from "@songtradr-sso/shared/frontend";

// TEXT

// STYLES

// DATA

// TYPES
export type LoaderData = {
  tempTokenCheck: ReturnType<typeof tempTokenCheck>;
};

// CONSTANTS
const routes = allRoutes[App.Core];

export const MFA_LAYOUT_ID = "mfa-layout";

// FUNCTIONS
export const tempTokenCheck = async () => {
  const tempToken = sessionStorage.getItem("auth_tmp");
  if (!tempToken) await redirect(routes.base);
};

// ASSETS
